// extracted by mini-css-extract-plugin
export default {"content":"ComprovanteDePagamento_content__IAWZB","th_tr_Responsive":"ComprovanteDePagamento_th_tr_Responsive__8AOAj"};